"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               v5.29.3
// source: standard_status.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardStatus = exports.protobufPackage = void 0;
exports.standardStatusFromJSON = standardStatusFromJSON;
exports.standardStatusToJSON = standardStatusToJSON;
/* eslint-disable */
exports.protobufPackage = "domain";
/** See: https://ddwiki.reso.org/display/DDW20/StandardStatus+Lookups */
var StandardStatus;
(function (StandardStatus) {
    StandardStatus[StandardStatus["STANDARD_STATUS_UNSPECIFIED"] = 0] = "STANDARD_STATUS_UNSPECIFIED";
    StandardStatus[StandardStatus["STANDARD_STATUS_ACTIVE"] = 1] = "STANDARD_STATUS_ACTIVE";
    StandardStatus[StandardStatus["STANDARD_STATUS_ACTIVE_UNDER_CONTRACT"] = 2] = "STANDARD_STATUS_ACTIVE_UNDER_CONTRACT";
    StandardStatus[StandardStatus["STANDARD_STATUS_CANCELED"] = 3] = "STANDARD_STATUS_CANCELED";
    StandardStatus[StandardStatus["STANDARD_STATUS_CLOSED"] = 4] = "STANDARD_STATUS_CLOSED";
    StandardStatus[StandardStatus["STANDARD_STATUS_COMING_SOON"] = 5] = "STANDARD_STATUS_COMING_SOON";
    StandardStatus[StandardStatus["STANDARD_STATUS_DELETE"] = 6] = "STANDARD_STATUS_DELETE";
    StandardStatus[StandardStatus["STANDARD_STATUS_EXPIRED"] = 7] = "STANDARD_STATUS_EXPIRED";
    StandardStatus[StandardStatus["STANDARD_STATUS_HOLD"] = 8] = "STANDARD_STATUS_HOLD";
    StandardStatus[StandardStatus["STANDARD_STATUS_INCOMPLETE"] = 9] = "STANDARD_STATUS_INCOMPLETE";
    StandardStatus[StandardStatus["STANDARD_STATUS_PENDING"] = 10] = "STANDARD_STATUS_PENDING";
    StandardStatus[StandardStatus["STANDARD_STATUS_WITHDRAWN"] = 11] = "STANDARD_STATUS_WITHDRAWN";
    StandardStatus[StandardStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(StandardStatus || (exports.StandardStatus = StandardStatus = {}));
function standardStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "STANDARD_STATUS_UNSPECIFIED":
            return StandardStatus.STANDARD_STATUS_UNSPECIFIED;
        case 1:
        case "STANDARD_STATUS_ACTIVE":
            return StandardStatus.STANDARD_STATUS_ACTIVE;
        case 2:
        case "STANDARD_STATUS_ACTIVE_UNDER_CONTRACT":
            return StandardStatus.STANDARD_STATUS_ACTIVE_UNDER_CONTRACT;
        case 3:
        case "STANDARD_STATUS_CANCELED":
            return StandardStatus.STANDARD_STATUS_CANCELED;
        case 4:
        case "STANDARD_STATUS_CLOSED":
            return StandardStatus.STANDARD_STATUS_CLOSED;
        case 5:
        case "STANDARD_STATUS_COMING_SOON":
            return StandardStatus.STANDARD_STATUS_COMING_SOON;
        case 6:
        case "STANDARD_STATUS_DELETE":
            return StandardStatus.STANDARD_STATUS_DELETE;
        case 7:
        case "STANDARD_STATUS_EXPIRED":
            return StandardStatus.STANDARD_STATUS_EXPIRED;
        case 8:
        case "STANDARD_STATUS_HOLD":
            return StandardStatus.STANDARD_STATUS_HOLD;
        case 9:
        case "STANDARD_STATUS_INCOMPLETE":
            return StandardStatus.STANDARD_STATUS_INCOMPLETE;
        case 10:
        case "STANDARD_STATUS_PENDING":
            return StandardStatus.STANDARD_STATUS_PENDING;
        case 11:
        case "STANDARD_STATUS_WITHDRAWN":
            return StandardStatus.STANDARD_STATUS_WITHDRAWN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return StandardStatus.UNRECOGNIZED;
    }
}
function standardStatusToJSON(object) {
    switch (object) {
        case StandardStatus.STANDARD_STATUS_UNSPECIFIED:
            return "STANDARD_STATUS_UNSPECIFIED";
        case StandardStatus.STANDARD_STATUS_ACTIVE:
            return "STANDARD_STATUS_ACTIVE";
        case StandardStatus.STANDARD_STATUS_ACTIVE_UNDER_CONTRACT:
            return "STANDARD_STATUS_ACTIVE_UNDER_CONTRACT";
        case StandardStatus.STANDARD_STATUS_CANCELED:
            return "STANDARD_STATUS_CANCELED";
        case StandardStatus.STANDARD_STATUS_CLOSED:
            return "STANDARD_STATUS_CLOSED";
        case StandardStatus.STANDARD_STATUS_COMING_SOON:
            return "STANDARD_STATUS_COMING_SOON";
        case StandardStatus.STANDARD_STATUS_DELETE:
            return "STANDARD_STATUS_DELETE";
        case StandardStatus.STANDARD_STATUS_EXPIRED:
            return "STANDARD_STATUS_EXPIRED";
        case StandardStatus.STANDARD_STATUS_HOLD:
            return "STANDARD_STATUS_HOLD";
        case StandardStatus.STANDARD_STATUS_INCOMPLETE:
            return "STANDARD_STATUS_INCOMPLETE";
        case StandardStatus.STANDARD_STATUS_PENDING:
            return "STANDARD_STATUS_PENDING";
        case StandardStatus.STANDARD_STATUS_WITHDRAWN:
            return "STANDARD_STATUS_WITHDRAWN";
        case StandardStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
//# sourceMappingURL=standard_status.js.map